import { defineComponent as _defineComponent } from 'vue'
import { watch, onMounted } from 'vue';
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'AmountBox',
  props: {
  custom_amount: Boolean,
  title: String,
  symbol: String,
  symbols: Object,
  strings: Object,
  display_amount: Number,
  min_donation_amount: Number,
  max_donation_amount: Number,
  show_min_max_donation: Boolean,
  post_type: String
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const getSymbol = () => {
  return props.symbols?.[store.currency] ?? props.symbol;
};

const isNumber = (evt: KeyboardEvent) => {
  const charCode = evt.which || evt.keyCode;
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    evt.preventDefault();
  }
};

const updateAmount = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.value) {
    store.amount = parseFloat(target.value);
  } else {
    store.amount = null; // Ensure the amount is null if the input is empty
  }
};

onMounted(() => {
  store.amount = null; // Ensure the amount is null on component mount
});

// watch(() => store.amount, (val) => {
//   if (props.show_min_max_donation) {
//     if (['cause', 'wp_commerce_forms'].includes(props.post_type)) {
//       if (val > props.max_donation_amount) {
//         store.amount = props.max_donation_amount;
//         ElNotification({
//           title: 'Error',
//           message: `Amount should be less than ${props.max_donation_amount}`,
//           type: 'error',
//           duration: 5000,
//           showClose: true
//         });
//       }
//       if (val < props.min_donation_amount) {
//         store.amount = props.min_donation_amount;
//         ElNotification({
//           title: 'Error',
//           message: `Amount should be greater than ${props.min_donation_amount}`,
//           type: 'error',
//           duration: 5000,
//           showClose: true
//         });
//       }
//     }
//   }
// });

const __returned__ = { store, props, getSymbol, isNumber, updateAmount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})